import { Flex, Image, Typography } from "antd";
import { RegistrationMediaFile } from "../../models/registration";
import { normalizeMediaFiles } from "../../utils/registrationFormResponse";

type FormResponseFilePreviewProps = {
  value: unknown;
};

const FormResponseFilePreview = ({ value }: FormResponseFilePreviewProps) => {
  const files = normalizeMediaFiles(value);

  if (files.length === 0) {
    return <Typography.Text type="secondary">—</Typography.Text>;
  }

  return (
    <Image.PreviewGroup>
      <Flex gap={10} wrap="wrap">
        {files.map((file: RegistrationMediaFile, index) => {
          const previewSrc = file.url || file.md || file.g || file.thumbnail;
          const thumbSrc = file.thumbnail || file.sd || file.url;

          return (
            <Flex key={file.uid || `${file.name}-${index}`} vertical gap={4}>
              <Image
                src={thumbSrc}
                alt={file.name || "Upload"}
                width={96}
                height={96}
                style={{
                  objectFit: "cover",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                }}
                preview={
                  previewSrc
                    ? {
                        src: previewSrc,
                      }
                    : false
                }
              />
              {file.name ? (
                <Typography.Text
                  type="secondary"
                  ellipsis
                  style={{ fontSize: 11, maxWidth: 96 }}
                >
                  {file.name}
                </Typography.Text>
              ) : null}
            </Flex>
          );
        })}
      </Flex>
    </Image.PreviewGroup>
  );
};

export default FormResponseFilePreview;
